<script lang="ts">
  import { onMount } from 'svelte'
  import { api, type Category } from '../lib/api'
  import { notify } from '../lib/toast'
  import Modal from '../components/Modal.svelte'

  let cats = $state<Category[]>([])
  let search = $state('')

  let addOpen = $state(false), editOpen = $state(false)
  let editing = $state<Category | null>(null)

  let newKey = $state(''), newName = $state(''), newDesc = $state(''), newAddrList = $state('VLESS_DOMAINS')
  let editKey = $state(''), editName = $state(''), editDesc = $state(''), editSort = $state(0), editAddrList = $state('VLESS_DOMAINS')

  async function load() { cats = await api.listCategories() }
  onMount(load)

  let visible = $derived(cats.filter(c => {
    if (!search) return true
    const hay = (c.name + ' ' + c.key + ' ' + (c.description || '')).toLowerCase()
    return hay.includes(search.toLowerCase())
  }))

  async function handleAdd() {
    if (!/^[a-z_][a-z0-9_]*$/.test(newKey)) return notify('Неверный ключ', 'err')
    try {
      await api.createCategory({ key: newKey, name: newName || newKey, description: newDesc || undefined, addressList: newAddrList || 'VLESS_DOMAINS' })
      notify('Создано', 'ok')
      addOpen = false; newKey = ''; newName = ''; newDesc = ''; newAddrList = 'VLESS_DOMAINS'
      await load()
    } catch (e: any) { notify(e.message, 'err') }
  }

  function openEdit(c: Category) {
    editing = c
    editKey = c.key; editName = c.name; editDesc = c.description || ''; editSort = c.sortOrder
    editAddrList = c.addressList || 'VLESS_DOMAINS'
    editOpen = true
  }

  async function handleEdit() {
    if (!editing) return
    try {
      await api.updateCategory(editing.id, { key: editKey, name: editName, description: editDesc, sortOrder: editSort, addressList: editAddrList })
      notify('Сохранено', 'ok'); editOpen = false; await load()
    } catch (e: any) { notify(e.message, 'err') }
  }

  async function handleDelete() {
    if (!editing) return
    if (!confirm(`Удалить категорию ${editing.key}? Все её домены будут удалены.`)) return
    try { await api.deleteCategory(editing.id); notify('Удалено', 'ok'); editOpen = false; await load() }
    catch (e: any) { notify(e.message, 'err') }
  }
</script>

<div class="card mb-4">
  <div class="flex flex-wrap gap-2 items-center">
    <input class="input flex-1 min-w-[200px]" placeholder="Поиск категории..." bind:value={search}>
    <button class="btn btn-primary" onclick={() => (addOpen = true)}>+ Категория</button>
  </div>
  <p class="text-xs text-muted mt-3">
    Категории нужны для группировки <b>доменов</b>. IP-диапазоны и Happ-правила управляются отдельно.
  </p>
</div>

<div class="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
  {#each visible as c (c.id)}
    <button class="card text-left hover:border-accent/50 transition-colors" onclick={() => openEdit(c)} title="key: {c.key}">
      <div class="flex justify-between items-start gap-2">
        <div class="flex-1 min-w-0">
          <div class="font-semibold truncate">{c.name}</div>
          {#if c.addressList && c.addressList !== 'VLESS_DOMAINS'}
            <span class="badge badge-red mt-1">→ {c.addressList}</span>
          {/if}
        </div>
        <div class="text-right flex-shrink-0">
          <div class="text-2xl font-bold text-accent leading-none">{c._count?.domains || 0}</div>
          <div class="text-[10px] text-muted uppercase tracking-wider mt-1">доменов</div>
        </div>
      </div>
      {#if c.description}
        <p class="text-xs text-muted mt-3 pt-2 border-t border-bg-border">{c.description}</p>
      {/if}
    </button>
  {/each}
</div>

{#if addOpen}
  <Modal title="Новая категория" onclose={() => (addOpen = false)}>
    <div class="space-y-3">
      <div><label class="label">Ключ (латиница)</label><input class="input" bind:value={newKey} placeholder="my_category" autofocus></div>
      <div><label class="label">Название</label><input class="input" bind:value={newName} placeholder="Моя категория"></div>
      <div>
        <label class="label">MikroTik address-list</label>
        <input class="input" bind:value={newAddrList} placeholder="VLESS_DOMAINS">
        <p class="text-xs text-muted mt-1">VLESS_DOMAINS — через VPN. Другие (BLOCKED, ADS) — для своих правил в firewall.</p>
      </div>
      <div><label class="label">Описание (опц.)</label><input class="input" bind:value={newDesc}></div>
    </div>
    {#snippet footer()}
      <button class="btn btn-secondary" onclick={() => (addOpen = false)}>Отмена</button>
      <button class="btn btn-primary" onclick={handleAdd}>Создать</button>
    {/snippet}
  </Modal>
{/if}

{#if editOpen && editing}
  <Modal title="Редактировать категорию" onclose={() => (editOpen = false)}>
    <div class="space-y-3">
      <div><label class="label">Ключ</label><input class="input" bind:value={editKey}></div>
      <div><label class="label">Название</label><input class="input" bind:value={editName}></div>
      <div>
        <label class="label">MikroTik address-list</label>
        <input class="input" bind:value={editAddrList}>
      </div>
      <div><label class="label">Описание</label><input class="input" bind:value={editDesc}></div>
      <div><label class="label">Порядок сортировки</label><input class="input" type="number" bind:value={editSort}></div>
    </div>
    {#snippet footer()}
      <button class="btn btn-danger mr-auto" onclick={handleDelete}>Удалить</button>
      <button class="btn btn-secondary" onclick={() => (editOpen = false)}>Отмена</button>
      <button class="btn btn-primary" onclick={handleEdit}>Сохранить</button>
    {/snippet}
  </Modal>
{/if}
